/**
 * Whether a witness can put you and something that is not you together.
 *
 * A complaint about a javelina is a complaint about a javelina. It lands on you
 * only when the person making it can connect you to the thing — and the only
 * way anybody in this game connects anything is by having perceived it. So the
 * question is asked of their perception and of nothing else:
 *
 *   they have you in view now    you were standing there when they spoke up
 *   they saw you with food       an orange in your hand, near a herd
 *   they saw you leading one     something following you, visibly
 *
 * The last two are conduct records like standing in the wrong room, and they
 * weigh nothing on the file's table: nobody grows suspicious of you for
 * carrying an orange. They exist so that somebody can say, afterwards, that
 * you were the one with the orange.
 *
 * Their own records, and not anybody else's. A guest can only blame who they
 * saw.
 */

/** The conduct kinds that tie a player to an animal. */
export const CONNECTS = Object.freeze(new Set(['food', 'leading']));

export function connectedTo(perception, witnessId) {
  if (perception.sees(witnessId)) return true;
  return perception.by(witnessId).some((record) => !record.subject && CONNECTS.has(record.what));
}
